import React from 'react';

import animateScrollTo from 'animated-scroll-to';

import { DynamicComponent } from 'ctm-components';
import { ResponsiveLayout } from '@comparethemarketau/manor-layout';

import { PolicyComparisonXs } from './policy_comparison_xs';
import { PolicyComparisonSm } from './policy_comparison_sm';
import { PolicyComparisonMd } from './policy_comparison_md';
import { PolicyComparisonLg } from './policy_comparison_lg';

import { PageStyledWrapper } from '../products/page_styled_wrapper';

const ComparisonPageMain = () => {
    React.useEffect(() => () => {
        animateScrollTo(0);
    });

    return (
        <DynamicComponent component={(
            <PageStyledWrapper className={'test-comparisonPage-main'}>
                <ResponsiveLayout is={'xs'}>
                    <PolicyComparisonXs />
                </ResponsiveLayout>
                <ResponsiveLayout is={'sm'}>
                    <PolicyComparisonSm />
                </ResponsiveLayout>
                <ResponsiveLayout is={'md'}>
                    <PolicyComparisonMd />
                </ResponsiveLayout>
                <ResponsiveLayout isFrom={'lg'}>
                    <PolicyComparisonLg />
                </ResponsiveLayout>
            </PageStyledWrapper>
        )} />
    );
};

export { ComparisonPageMain };
